<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="110px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="店铺名称" prop="storeCode">
          <el-select v-model="searchForm.storeCode" multiple collapse-tags clearable style="width: 240px">
            <el-option v-for="item in storeList" :key="item.storeCode" :label="item.shortName" :value="item.storeCode"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上市清单名称" prop="name">
          <el-input v-model.trim="searchForm.name" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="商品编码" prop="skuCode">
          <el-input v-model.trim="searchForm.skuCode" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="商品名称" prop="skuName">
          <el-input v-model.trim="searchForm.skuName" @keyup.enter.native="onSearch" />
        </el-form-item>
        <el-form-item label="上架状态" prop="state">
          <el-select v-model="searchForm.state" multiple collapse-tags clearable>
            <el-option label="待上架" :value="0"></el-option>
            <el-option label="暂缓上架" :value="1"></el-option>
            <el-option label="无需上架" :value="2"></el-option>
            <el-option label="已上架" :value="3"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="发布时间">
          <form-date-range
            :form="searchForm"
            startKey="dts"
            endKey="dte"
            :usingTime="false"
            valueFormat="yyyy-MM-dd"
          ></form-date-range>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column prop="skuCode" label="商品编码" min-width="150"></el-table-column>
        <el-table-column prop="goodsName" label="商品名称" min-width="200"></el-table-column>
        <el-table-column prop="storeName" label="店铺名称" min-width="120"></el-table-column>
        <el-table-column prop="userName" label="负责人" min-width="200"></el-table-column>
        <el-table-column prop="name" label="涉及上市清单名称" min-width="180">
          <template slot-scope="{row}">
            <el-button type="text" @click="goListingList(row)">{{ row.name }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="publishDate" label="清单发布时间" min-width="90"></el-table-column>
        <el-table-column prop="upType" label="上架标识" min-width="80"></el-table-column>
        <el-table-column prop="sendCycle" label="商品发货周期" min-width="100"></el-table-column>
        <el-table-column prop="state" label="上架状态" min-width="80"></el-table-column>
        <el-table-column prop="operationName" label="操作人" min-width="80"></el-table-column>
        <el-table-column prop="operationDate" label="操作时间" min-width="150"></el-table-column>
        <el-table-column prop="reason" label="暂缓上架原因" min-width="120"></el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[10, 30, 60, 90]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
  </div>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'GoodsData',
  mixins: [tableMixin, pagePathMixin],
  components: { },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      tableReload: true,
      isShowRecord: false,
      searchFormData: [],
      rules: {},
      rowData: {},
      searchForm: {
        skuCode: '',
        spuCode: '',
        skuName: '',
        state: [],
        storeCode: [],
        name: '',
        dts: '',
        dte: '',
        listNo: '',
      },
      storeList: [],
    };
  },
  mounted() {
    this.loading = true;
    this.getStoreList();
    setTimeout(() => {
      this.onSearch();
    }, 200);
  },
  methods: {
    onSearch() {
      this.tableData.pageNum = 1;
      this.init();
    },

    async init() {
      this.loading = true;
      let data = {
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
        filterData: {
          ...this.searchForm,
        },
      };
      this.searchFormData = data;
      this.$q.newProduct
        .productListUpDetailList({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init();
    },

    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init();
    },

    reset() {
      this.searchForm = {
        skuCode: '',
        spuCode: '',
        skuName: '',
        state: [],
        storeCode: [],
        name: '',
        dts: '',
        dte: '',
        listNo: '',
      };
      this.onSearch();
    },

    getStoreList() {
      let data = {
        pageNum: 1,
        pageSize: 999999,
        filterData: {
          newArrival: 1,
        },
      };
      this.searchFormData = data;
      this.$q.configurationCenter.storeManagePage({ data: data }).then((res) => {
        if (res.code == 200) {
          this.storeList = res.data.list;
        }
      });
    },


    goListingList(row) {
      this.$router.push({ path: '/newProduct/listingList', query: {name: row.name} });
    },

    // 导出
    exportExcel() {
      const loading = this.$loading({
        lock: true,
        text: '导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      let params = {
        appCode: 'ec-pc-api',
        paramMap: {
          ...this.searchFormData.filterData,
        },
        reportName: 'newProductListUpDetail',
      };
      this.$q.common.exportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success('提交下载任务成功，请稍后到导出列表查阅！');
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-in-tab {
  >>> .search-outer>div {
    padding: 0;
  }
}

.search-box
  >>> .el-date-editor.el-input__inner, >>> .el-select, >>> .el-input
      width 240px !important
  >>> .date-range .single-date
    width 110px !important

>>> .form-number-input .el-input-number {
  width: 105px !important;
}

>>> .form-number-input .el-input-number .el-input {
  width: 105px !important;
}

.header-with-tips {
  display: flex;
  align-items: center;

  .el-icon-question {
    margin-left: 5px;
    color: #909399;
    cursor: pointer;
  }
}
</style>
